import { Icon, type IconProps } from './Icon';

/** Diminuir, no stepper. Substitui o `−` (U+2212). */
export function MinusIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M5 12h14" />
    </Icon>
  );
}
